export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('recursive-menu-sync-button', {
        createInput({ trait }) {
            const wrapper = document.createElement('div');
            wrapper.style.display = 'flex';
            wrapper.style.width = '100%';

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'gjs-btn-prim';
            button.style.width = '100%';
            button.textContent =
                trait.get?.('text') || 'Menuliste synchronisieren';

            button.addEventListener('click', () => {
                const component = trait.target;
                if (!component) return;

                if (typeof component.reconstructTraitHierarchy === 'function') {
                    component.reconstructTraitHierarchy();
                }
                if (typeof component.updateMenuView === 'function') {
                    component.updateMenuView();
                }
                editor.trigger('component:selected', component);
            });

            wrapper.appendChild(button);

            setTimeout(() => {
                const traitRow = wrapper.closest('.gjs-trait');
                const labelWrap = traitRow?.querySelector('.gjs-label-wrp');
                const fieldWrap = traitRow?.querySelector('.gjs-field-wrp');
                if (labelWrap) {
                    labelWrap.style.display = 'none';
                }
                if (fieldWrap) {
                    fieldWrap.style.width = '100%';
                }
            }, 0);

            return wrapper;
        },
    });

    editor.TraitManager.addType('recursive-menu-select', {
        createInput({ trait }) {
            const input = document.createElement('select');
            input.className = 'menu-level';

            // Get options from trait - with better fallback handling
            let options = [];
            if (trait.get) {
                options = trait.get('options') || [];
            } else if (trait.options) {
                options = trait.options;
            } else if (menuConfig && menuConfig.header) {
                // Fallback to menuConfig if options not found in trait
                options = menuConfig.header.map((item) => ({
                    name: item.label || item.name || 'Unnamed',
                    value: item.identifier || item.label || item.name || 'unnamed',
                    items: item.items || [],
                }));
            }


            // Add default option
            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = 'Select an option...';
            input.appendChild(defaultOption);

            // Populate dropdown
            options.forEach((opt) => {
                const option = document.createElement('option');
                option.value = opt.value;
                option.textContent = opt.name;
                input.appendChild(option);
            });

            // On change, update trait and show next level
            input.addEventListener('change', (e) => {
                const value = e.target.value;
                if (!value) return; // Don't process empty selection

                const selected = options.find((o) => o.value === value);
                const subItems = selected?.items || [];

                // Get component and current traits
                const component = trait.target;
                const currentTraits = component.get('traits');
                const currentTraitName = trait.get ? trait.get('name') : trait.name;
                const index = currentTraits.findIndex(
                    (t) => (t.get ? t.get('name') : t.name) === currentTraitName
                );
                const currentLevelNumber = parseInt(
                    String(currentTraitName).split('-')[2],
                    10
                );

                // Update the component's attribute FIRST
                const attrs = component.getAttributes();
                attrs[currentTraitName] = value;
                component.setAttributes(attrs);

                // Remove traits beyond this level
                const persistentTraits = currentTraits.filter((t) => {
                    const name = t.get ? t.get('name') : t.name;
                    return !String(name || '').startsWith('menu-level-');
                });
                const levelTraitsToKeep = currentTraits.filter((t) => {
                    const name = t.get ? t.get('name') : t.name;
                    if (!String(name || '').startsWith('menu-level-')) {
                        return false;
                    }
                    const levelNum = parseInt(String(name).split('-')[2], 10);
                    return levelNum <= currentLevelNumber;
                });
                const traitsToKeep = [...persistentTraits, ...levelTraitsToKeep];
                component.set('traits', traitsToKeep);
                // Add next level if sub-items exist
                if (subItems.length > 0 && subItems?.some(i => i?.items?.length > 0)) {
                    const nextLevel = currentLevelNumber + 1;
                    // Create new trait object
                    const newTrait = {
                        type: 'recursive-menu-select',
                        name: `menu-level-${nextLevel}`,
                        label: `Menu Level ${nextLevel}`,
                        options: subItems.map((item) => ({
                            name: item.label,
                            value: item.identifier || item.label,
                            items: item.items || [],
                        })),
                    };

                    // Use setTimeout to ensure the UI has time to update
                    setTimeout(() => {
                        component.addTrait(newTrait);
                        // Force refresh the traits panel
                        editor.trigger('component:selected', component);
                    }, 10);
                } else {
                    // If no sub-items, make sure to clean up any remaining level attributes
                    const allAttrs = component.getAttributes();
                    Object.keys(allAttrs).forEach(key => {
                        if (key.startsWith('menu-level-')) {
                            const levelNum = parseInt(key.split('-')[2]);
                            if (levelNum > currentLevelNumber) {
                                delete allAttrs[key];
                            }
                        }
                    });
                    component.setAttributes(allAttrs);
                }
            });

            return input;
        },

        onUpdate({ elInput, trait }) {
            const traitName = trait.get ? trait.get('name') : trait.name;
            const value = trait.target.getAttributes()[traitName];
            if (value && elInput) {
                elInput.value = value;
            }
        },
    });
};
